// extracted by mini-css-extract-plugin
export default {"homeBody":"HomeBody_homeBody__d4fW7","colabPend":"HomeBody_colabPend__Xrt9B","colabOk":"HomeBody_colabOk__14DpW"};